import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { assignMetric } from './formData';
import { superAdminAction } from '../../../../_actions';
import AccessData from '../../../../_components/common/AccessData';
import tableSort from '../../../../_components/common/Sort';



import _ from 'lodash'

class AssignRespondentsToOrg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            assignMetric: false,
            allowAccess: false,
            denyAccess: false,
            updateModalState: false,
            updateMessage: null,
            deleteCompetency: false,
            editCompetency: false,
            sortType: false,
            checkBoxData: [],
            buttonData: [],
            competencyDetailsModal: false,
            
            analyticsMetricList: [],
            analyticsMetricListLoader: true,

            competencyDetails: null,
            navData: [],

            organsiation_assessor_groups: [],
            unChanged_organsiation_assessor_groups: [],
            selectedAssessorGroup: "0"
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.setState({
            orgId: +this.props.match.params.id
        })
        
        const fd = {
            'analytics_orgnisation': id
        }

        this.props.dispatch(superAdminAction.assessor_groupList(fd, (response) => {
            this.setState({
                organsiation_assessor_groups: response.data.organsiation_assessor_groups,
                unChanged_organsiation_assessor_groups: response.data.organsiation_assessor_groups
            })
        }))

        this.props.dispatch(superAdminAction.getAssessment_groupsList(this.props.match.params.id,(response_addedd_assessor) => {
            this.getAssessorTableList(fd.analytics_orgnisation, response_addedd_assessor)
        }))

        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Allow Access',
                    toggler: this.toggleAllowAccessModal.bind(this),
                    togglerModal: this.state.allowAccess,
                    icon: 'fa fa-plus',
                    disabled: 'disabled',
                    title: 'ADD'
                },
                {
                    id: 2,
                    name: 'Deny Access',
                    toggler: this.toggleDenyAccessModal.bind(this),
                    togglerModal: this.state.denyAccess,
                    icon: 'fa fa-minus',
                    disabled: 'disabled',
                    title: 'DEL'
                }
            ]
        })
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    getAssessorTableList = (analytics_orgnisation, added_assessorList) => {
        this.props.dispatch(superAdminAction.assessor_groupList({
            'analytics_orgnisation': analytics_orgnisation
        }, (response) => {

            //response will be more than or equal to added_assessorList

            let formatedData = []
                        
            response.data.organsiation_assessor_groups.map(function(obj) { 
                let count = 0;
                for (let i = 0; i < added_assessorList.data.organsiation_assessor_groups.length; i++) {
                    if (added_assessorList.data.organsiation_assessor_groups[i].assessor_group_id === obj.assessor_group_id) {
                        count = count + 1;
                    }
                }
                if (count > 0) {
                    formatedData.push({
                        ...obj,
                        'access': ' fa fa-check text-success',
                    })
                }
                if (count === 0) {
                    formatedData.push({
                        ...obj,
                        'access': ' fa fa-times text-danger',
                    })
                }
            });

                      
            const ProperArrayFiltered = formatedData;



            const analyticsMetricList = ProperArrayFiltered.map(val => {
                return {
                    ...val,
                    'rowCheck': true,                    
                }
            })

            const analyticsMetricListId = analyticsMetricList.map(val => {
                return val.assessor_group_id
            })

            const organsiation_assessor_groups_filtered = this.state.unChanged_organsiation_assessor_groups.filter( ( el ) => !analyticsMetricListId.includes( el.assessor_group_id ) );
                        

            this.setState({
                organsiation_assessor_groups: organsiation_assessor_groups_filtered,
                analyticsMetricList: analyticsMetricList,
                analyticsMetricListLoader: false
            }, () => {

            })
        }))
    }

    componentDidUpdate(prevProps, prevState) {
        // getMetricsListResponse, getAnalyticsMetricListResponse
        if (prevProps.getAnalyticsMetricListResponse !== this.props.getAnalyticsMetricListResponse) {
            if (this.props.getAnalyticsMetricListResponse !== '' && this.props.getMetricsListResponse !== '') {
                this.setState({
                    analyticsMetricList: this.getReformatTableData(this.props.getMetricsListResponse, this.props.getAnalyticsMetricListResponse)
                })
            }
        }
        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }


    toggleAllowAccessModal(showModal) {
        this.setState({
            allowAccess: showModal
        })
    }

    toggleDenyAccessModal(showModal) {
        this.setState({
            denyAccess: showModal
        })
    }

    toggleEntireAssignMetricModal(showModal) {
        this.setState({
            allowAccess: showModal,
            denyAccess: showModal,
            competencyDetailsModal: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.analyticsMetricList
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ analyticsMetricList: arrayCopy });
    }

    changeAssessorGroupList = (e) => {
        this.setState({
            selectedAssessorGroup: e.target.value
        })
    }

    getAccessModalData = (checkBoxData) => {

        return (
            <div className="d-flex justify-content-center align-items-center p-2">
                <label className="px-2" for="assessor_group_id">Assessor Groups</label>
                <select className="px-2" onChange={(e) => this.changeAssessorGroupList(e)}>
                    <option value="0">Choose a Relation</option>
                    {
                        this.state.organsiation_assessor_groups.map(val => (
                            <option value={val.assessor_group_id}>{val.assessor_group__assessor_name}</option>
                        ))
                    }
                </select>
            </div>
        )

    }

    // This method is used to set the checkbox data in state
    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    toggleDetailsCompetency(showModal) {
        this.setState({
            competencyDetailsModal: true,
            competencyDetails: showModal
        })
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {

            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {


                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    getCompetencyDetails() {

        const subTable = {
            data: [{
                name: 'Attribute Name',
                key: 'attribute__attribute_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'

            },
            {
                name: 'Competency Weight',
                key: 'competency_weight',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'
            },]
        }

        const subTableData = []
        this.state.competencyDetails.competency_values.map(
            (data, i) => {
                if (i < this.state.competencyDetails.competency_values.length) {
                    subTableData.push(
                        {
                            attribute__attribute_name: data.attribute__attribute_name,
                            competency_weight: data.competency_weight + '%'
                        }
                    )
                }
                if (i + 1 === this.state.competencyDetails.competency_values.length) {
                    subTableData.push(
                        {
                            attribute__attribute_name: 'Total',
                            competency_weight: '100%',
                            color: 'rgb(0, 128, 0)'
                        }
                    )
                }
            }
        )

        const returnData =
            <TableNew
                data={subTableData}
                columns={subTable.data}

            />

        return returnData
    }

    actionSelectedAccess = (type) => {
        if (type === 'Add') {
            this.props.dispatch(superAdminAction.postAssessment_groupsList({
                orgId: this.props.match.params.id,
                data: {
                    assessor_group_id: this.state.checkBoxData.map(val => val.assessor_group_id)
                }
            }, (response_add_assessor) => {
                this.props.dispatch(superAdminAction.getAssessment_groupsList(this.props.match.params.id,(response_addedd_assessor) => {
                    this.getAssessorTableList(this.props.match.params.id, response_addedd_assessor)
                    this.updateMessageFunc(response_add_assessor)
                }))
            }))
        }else if(type === 'Remove') {
            const assessor_group_id = this.state.checkBoxData.map(val => {
                return val.assessor_group_id
            })
            this.props.dispatch(superAdminAction.removeAssessorGroup({data: {
                organisation_assessor_id: {organisation_assessor_id: assessor_group_id},
                orgId: +this.props.match.params.id
            }}, (response_remove_assessor) => {
                this.props.dispatch(superAdminAction.getAssessment_groupsList(this.props.match.params.id,(response_addedd_assessor) => {
                    this.getAssessorTableList(this.props.match.params.id, response_addedd_assessor)
                    this.updateMessageFunc(response_remove_assessor)
                }))
            }))
        }
        this.setState({
            allowAccess: false,
            denyAccess: false
        })
    }

    getReformatTableData = (getMetricsListResponse, getAnalyticsMetricListResponse) => {
        let formatedData = []
        getMetricsListResponse.map(
            (data, i) => {
                let count = 0;
                for (let i = 0; i < getAnalyticsMetricListResponse.length; i++) {
                    if (getAnalyticsMetricListResponse[i].competency_metric__id === data.id) {
                        count = count + 1;
                    }
                }
                if (count > 0) {
                    formatedData.push({
                        ...data,
                        'rowCheck': true,
                        'access': ' fa fa-check text-success',
                    })
                }
                if (count === 0) {
                    formatedData.push({
                        ...data,
                        'rowCheck': true,
                        'access': ' fa fa-times text-danger',
                    })
                }
            }
        )
        return formatedData
    }


    getOrgData(checkBoxData) {
        const headings = [{
            'name': 'Assessor Name',
            'textCenter':false
        },{
            'name': 'Access',
            'textCenter':true
        }]
        const keyNames = [{
            'name': 'assessor_group__assessor_name'
        },]
       return AccessData(checkBoxData, headings, keyNames)
    }

    updateMessageFunc = (response) => {
        this.setState({
            updateMessage: {
                status: response.status,
                text: `<div className = " text-center">
                <p className = "font-weight-bold">${(response.status === 200 || response.status === 201) ? 'Success!' : 'Error!'}</p>
                <p> ${response.data.message}.</p>
            </div>`,
                heading: response.config.url.includes('assessment_groups/delete') ? 'Remove Assessor' : 'Assign Assessor',
                headerColor: (response.status === 200 || response.status === 201) ? `` : `bg-danger`,
                headingIcon: (response.status === 200 || response.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
            },
            updateModalState: true
        })
    }

    render() {

        const { getMetricsListResponse, getAnalyticsMetricListResponse } = this.props;

        const tables = {
            Team: [{
                name: 'Assessor Name',
                key: 'assessor_group__assessor_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            },{
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
            }]
        }


        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">ASSIGN RELATIONS</h5>
                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            this.state.analyticsMetricListLoader ?
                                <p className="text-center">
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                    &nbsp;Loading</p>
                            :
                                <TableNew
                                    data={this.state.analyticsMetricList}
                                    columns={tables.Team}
                                    onClickDetailsButton={this.toggleDetailsCompetency.bind(this)}
                                    checkbox="true"
                                    selectCheckBox={this.selectAllAssessment.bind(this)}
                                    getData={this.getSelectedData.bind(this)}
                                    CheckKey={"assessor_group_id"}
                                    sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                    sortType={this.state.sortType}
                                    // pagination={true}
                                    // paginationAmount={5}
                                />
                        }

                        {
                            this.state.allowAccess &&
                            <ModalComponent

                                showModal={this.state.allowAccess}
                                heading="Add Assessor"
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.actionSelectedAccess(type)}

                            />
                        }

                        {
                            this.state.denyAccess &&
                            <ModalComponent

                                showModal={this.state.denyAccess}
                                heading="Delete Assessor"
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.actionSelectedAccess(type)}


                            />
                        }

                        {
                            this.state.competencyDetailsModal &&
                            <ModalComponent
                                showModal={this.state.competencyDetailsModal}
                                heading={'Competency - '+this.state.competencyDetails.competency_name}
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                htmlTag={this.getCompetencyDetails()}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => { this.setState({ competencyDetailsModal: false }) }}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>

                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { getMetricsListLoading } = state.getMetricsListReducer;
    const getMetricsListError = state.getMetricsListReducer.error;
    const getMetricsListResponse = (!getMetricsListLoading && !getMetricsListError) ? state.getMetricsListReducer.data.data.competency_metrics : '';

    const { getAnalyticsMetricListLoading } = state.getAnalyticsMetricListReducer;
    const getAnalyticsMetricListError = state.getAnalyticsMetricListReducer.error;
    const getAnalyticsMetricListResponse = (!getAnalyticsMetricListLoading && !getAnalyticsMetricListError) ? state.getAnalyticsMetricListReducer.data.data.competency_metrices : '';

         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    return {
        getMetricsListResponse,
        getAnalyticsMetricListResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(AssignRespondentsToOrg);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/AssignRespondentToOrg/index.js